import { render, staticRenderFns } from "./ErrorPopUp.vue?vue&type=template&id=2bc2e07a&scoped=true&"
import script from "./ErrorPopUp.vue?vue&type=script&lang=js&"
export * from "./ErrorPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ErrorPopUp.vue?vue&type=style&index=0&id=2bc2e07a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc2e07a",
  null
  
)

export default component.exports